import { EnvironmentName, OrgillEnvironment } from "./environment.interface";

export const environment: OrgillEnvironment = {
	production: false,
	environmentName: EnvironmentName.DEV,
};
